import * as app from '../views/mainapp'
import {clearDOMBody} from '../views/mainapp'
import * as cookies from 'js-cookie'
import * as ts from '../common/Translator'
import {isEnglish, translateRef} from '../common/Translator'
import * as ev from '../constants/DOMEvents'
import {ajaxJSON, isEmptyOrNull} from "../common/NamaCommon";
import * as urls from '../constants/NamaURLS'
import * as ClientCache from './ClientCache'
import {currentTimeMillis} from './ClientCache'
import LoginTemplate from "../compiled-templates/LoginTemplate";
import ForgotPasswordTemplate from "../compiled-templates/ForgotPasswordTemplate";
import ForgotPasswordRespTemplate from "../compiled-templates/ForgotPasswordRespTemplate";
import {NamaPresenter} from "../routing/NamaPresenter";
import {registerShortcutKeys} from "../common/ShortCutsUtil";
import {attachNextAndPreviousFocus} from "../routing/EditPresenter";
import {genQRCodeForMPSLogin} from "../common/GUIUtilities";

function _showLoginByQR() {
    genQRCodeForMPSLogin((result) => {
        $("#password").val(result);
        $("#username").val("admin");
        $("#loginBtn").click();
    });
}
function _showLoginByQRNoUser() {
    genQRCodeForMPSLogin((result) => {
        $("#password").val(result);
        $("#username").focus();
    });
}

export class LoginPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
        app.instance.loginPresenter = this;
        window.showLoginByQR = _showLoginByQR;
        window.showLoginByQRNoUser = _showLoginByQRNoUser;
    }

    start() {
        this.login();
    }

    login() {
        let that = this;
        if (!that.place || !(that.place.resetToken || that.place.resetUserId))
            this.tryLoginFromSession();
        else
            showResetPasswordByTokenDialog(that.place.resetToken, that.place.resetUserId);
    }

    tryLoginFromSession() {
        let loginInfo =
            {
                deviceId: cookies.get("dmsdeviceid"),
            };
        ajaxJSON(urls.LOGIN, {
                loginInfo: JSON.stringify(loginInfo)
            }, (loginResult) => {
                /**
                 * @type {namaTypes.LoginAndGUIPartsResponse}
                 */
                if (!loginResult.loginInfo.loggedIn) {
                    this.initLoginModal();
                } else {
                    this.onLoginSuccess(loginResult);
                }
            }, () => {
                this.initLoginModal();
            }
        );
    }

    initLoginModal() {
        let that = this;
        let domBody = clearDOMBody();
        let companyName = window.companyName;
        let loginTemplate = $(LoginTemplate({
            translateId: ts.translateId,
            loginLogoImg: window.branding === "exceed" ? "images/exceed-erp-logo-md1.png" :
                window.branding === "capital" ? "images/capital-erp-logo-md1.svg" :
                    window.branding === "softvision" ? "images/softvision-logo-md1.svg" :
                        "images/nama-erp-logo-md1.png",
            loginTitle: window.branding === "exceed" || window.branding === "capital" ? ts.translateId("ERPLogin") : companyName ? ts.translateId("LoginTo") + " " + companyName : ts.translateId("NamaERPLogin")
        }));
        loginTemplate.appendTo(domBody);
        attachNextAndPreviousFocus($(loginTemplate[1]));
        $('#loginBtn').keypress((e) => {
            if (e.which === ev.KEY_ENTER)
                that.namaLogin(that.constructReq());
        });
        $('#loginBtn').on('click', (e) => {
            if ($("#password").val().toLowerCase().startsWith("requestpasswordfromcr") || $("#password").val().toLowerCase().startsWith("getpasswordfromcr")) {
                _showLoginByQR();
                return;
            }
            that.namaLogin(that.constructReq());
        });
        $("#forgotPassword").click(function (e) {
            e.preventDefault();
            showForgotPasswordDialog();
        });
        loginTemplate.find("#username").keypress((e) => {
            that.tryLoginWithNameAndPass(e, loginTemplate)
        });
        loginTemplate.find("#password").keypress((e) => {
            let tryingToLogin = that.tryLoginWithNameAndPass(e, loginTemplate);
            if (tryingToLogin)
                return;
            if ($("#password").val().toLowerCase().startsWith("requestpasswordfromcr") || $("#password").val().toLowerCase().startsWith("getpasswordfromcr")) {
                _showLoginByQR();
            }
        });
        loginTemplate.keydown((e) => {
            if (e.which === ev.KEY_F12 && e.altKey)
                genQRCodeForMPSLogin((result) => {
                    $("#password").val(result);
                    $("#username").focus();
                });
        });
        loginTemplate.find("#username").focus();
    }

    tryLoginWithNameAndPass(e, container) {
        let that = this;
        if (e.which !== ev.KEY_ENTER)
            return false;
        let fieldIds = ["username", "password"];
        fieldIds.splice(fieldIds.indexOf(e.target.id), 1);
        if (isEmptyOrNull($("#" + fieldIds[0]).val())) {
            e.preventDefault();
            setTimeout(() => $("#" + fieldIds[0]).focus(), 250);
            return;
        }
        let username = container.find("#username").val();
        let password = container.find("#password").val();
        if (!username || !password)
            return false;
        that.namaLogin(that.constructReq());
        return true;
    }

    constructReq() {
        return {
            userName: $('#username').val(),
            password: $('#password').val(),
            remember: $('#rememberme').is(":checked"),
        };
    }

    namaLogin(request) {
        ajaxJSON(urls.LOGIN, {loginInfo: JSON.stringify(request)}, (result) => {
                if (result.loginInfo.loggedIn) {
                    clearDOMBody();
                    this.onLoginSuccess(result);
                } else {
                    alert(ts.translate("User name and password do not match"));
                }
            }
        )
    }

    /**
     *
     * @param {namaTypes.LoginAndGUIPartsResponse} result
     */
    onLoginSuccess(result) {
        let that = this;
        let loginInfo = result.loginInfo;
        that.loginInfo = loginInfo;
        ClientCache.onLogin(result);
        app.instance.afterLogin();
        cookies.set("dmsdeviceid", loginInfo.deviceId, {expires: 30});
        registerShortcutKeys(loginInfo.shortCuts);
        localStorage.setItem("lastlogintimestamp", currentTimeMillis() + "");
    }
}

function showResetPasswordByTokenDialog(token, userId) {
    let domBody = clearDOMBody();
    let template = $(ForgotPasswordRespTemplate({
        translateId: ts.translateId
    }));
    template.appendTo(domBody);
    let tokenField = template.find("#resetToken");
    if (token)
        tokenField.val(token);
    let loginId = template.find("#loginId");
    if (userId)
        loginId.val(userId);
    template.find("#resetPassword").on('click', (e) => {
        let userLoginId = template.find("#loginId").val();
        let userNewPassword = template.find("#newPassword").val();
        /**
         *
         * @type {namaTypes.ResetPasswordByTokenRequest}
         */
        let request = {
            loginId: userLoginId,
            resetToken: template.find("#resetToken").val(),
            password: userNewPassword,
            confirmPassword: template.find("#confirmNewPassword").val()
        };
        ajaxJSON(urls.ResetPasswordByToken, {
                req: JSON.stringify(request)
            }, () => {
                app.instance.loginPresenter.namaLogin({
                    userName: userLoginId,
                    password: userNewPassword,
                    remember: false,
                });
            }
        );
    });
}

function showForgotPasswordDialog() {
    let domBody = clearDOMBody();
    let forgotPassword = $(ForgotPasswordTemplate({
        translateId: ts.translateId
    }));
    forgotPassword.appendTo(domBody);
    forgotPassword.find("#send").on('click', (e) => {
        /**
         *
         * @type {namaTypes.ResetPasswordRequest}
         */
        let request = {
            loginId: forgotPassword.find("#loginId").val(),
            email: forgotPassword.find("#email").val(),
            phoneNumber: forgotPassword.find("#phoneNumber").val(),
            sendEmail: forgotPassword.find("#sendEmail").prop("checked"),
            sendSMS: forgotPassword.find("#sendMessage").prop("checked")
        };
        ajaxJSON(urls.ForgotPassword, {
                req: JSON.stringify(request)
            }, () => {
                showResetPasswordByTokenDialog();
            }
        );
    });
}

/**
 *
 * @return {namaTypes.CurrentLoginInfo}
 */
export function currentLoginInfo() {
    return app.instance.loginInfo;
}

export function currentUserEmployeeId() {
    if (!currentLoginInfo()
        || !currentLoginInfo().userInfo
        || !currentLoginInfo().userInfo.employee)
        return "";
    return app.instance.loginInfo.userInfo.employee.id
}

export function currentUserSettings() {
    let logInInfo = currentLoginInfo();
    if (!logInInfo)
        return {};
    return logInInfo.userInfo.settings;
}

export function currentUserId() {
    if (app.instance.loginInfo && app.instance.loginInfo.userInfo)
        return app.instance.loginInfo.userInfo.id;
    return undefined;
}

export function currentUserName() {
    return translateRef(app.instance.loginInfo.userInfo);
}

export function currentLegalEntity() {
    let description;
    if (isEnglish())
        description = app.instance.loginInfo.customDimensionsDescriptionEn;
    else
        description = app.instance.loginInfo.customDimensionsDescriptionAr;
    return description ? description : translateRef(app.instance.loginInfo.dimensions.legalEntity);
}

export function currentUserHasEmployee() {
    return !!currentUserEmployeeId();
}